import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
import { iconTheme } from '@cld/icon';

export const theme = createTheme(
  {
    size: {
      sm: {
        icon: iconTheme.sm,
        font: globalTheme.font.size.xxs,
      },
      md: {
        icon: iconTheme.md,
        font: globalTheme.font.size.xxs,
      },
      lg: {
        icon: iconTheme.lg,
        font: globalTheme.font.size.xxs,
      },
    },
  },
  'list-item-layout'
);

export const sizeVariant = createVariant((props) => theme.size[props.size]);
